import {vaKey} from '@/assets/utils/payment_method'

export default {
  SET_DATA_PAYMENT_GATEWAY (state, data) {
    state.va_payment_gateway = data.filter(it => it.category == vaKey)
    state.other_payment_gateway = [...data.filter(it => it.category != vaKey)]
    state.payment_gateway = data.filter(it => it.category == vaKey)
  },
  SET_ACTIVE_PAYMENT_GATEWAY(state, data) {
    state.payment_gateway = data
  },
  SET_SELECTED_PAYMENT(state, data) {
    state.selectedPayment = data
  },
  DELETE_SELECTED_PAYMENT(state) {
    state.selectedPayment = null
  }
}